export default __webpack_public_path__ + "static/wireframePlans-e8a8d75391884330d360f09daa0f6d85.png";